{
  "pageTitle": "Očitanja brojila",
  "pageDescription": "Uslikajte brojilo, AI pročita vrijednost, pregledate je i pošaljete gdje treba.",
  "action": {
    "takePhoto": "Uslikaj / Dodaj fotografiju",
    "choosePhoto": "Odaberi fotografiju iz galerije"
  },
  "notEnabled": {
    "title": "Očitanja brojila nisu omogućena",
    "description": "Omogućite očitanja brojila na adresnom provajderu pod Adrese da biste počeli slati očitanja.",
    "link": "Idi na Adrese"
  },
  "review": {
    "title": "Pregled očitanja",
    "readingValue": "Očitanje",
    "secondaryReadingValue": "Drugo očitanje",
    "meterNumber": "Broj brojila",
    "confidence": "Pouzdanost",
    "rawText": "Tekst sa brojila",
    "notes": "Napomene",
    "confidenceHigh": "Visoka",
    "confidenceMedium": "Srednja",
    "confidenceLow": "Niska",
    "editHint": "Ispravite očitanja ako je potrebno prije nastavka.",
    "confirmEmail": "Pošalji email",
    "confirmForm": "Pošalji",
    "retake": "Ponovi"
  },
  "settings": {
    "title": "Postavke očitanja brojila",
    "noAddress": "Nijedna adresa još nema omogućena očitanja brojila za ovog provajdera. Omogućite ih pod Adrese.",
    "linkHint": "Očitanja se šalju za adresu na kojoj ste omogućili očitanja brojila za ovog provajdera pod Adrese. Popunite podatke koji se šalju uz svako očitanje — mogu biti različiti po provajderu.",
    "reportName": "Ime i prezime",
    "reportAddress": "Adresa",
    "reportCustomerCode": "Šifra potrošača",
    "reportPhone": "Broj telefona",
    "reportEmail": "Email za izvještaj",
    "reportCc": "CC za izvještaj",
    "save": "Sačuvaj postavke",
    "saved": "Postavke sačuvane",
    "saveError": "Neuspješno čuvanje postavki",
    "loadError": "Neuspješno učitavanje postavki",
    "loadProvidersError": "Neuspješno učitavanje provajdera brojila",
    "missingWarning": "Popunite podatke za izvještaj ispod prije slanja očitanja brojila.",
    "missingRequired": "Molimo popunite sve podatke za izvještaj."
  },
  "history": {
    "title": "Nedavna očitanja",
    "empty": "Još nema očitanja",
    "emptyHint": "Otpremite fotografiju ili ručno unesite očitanje da započnete istoriju.",
    "statusExtracted": "Pročitano",
    "statusEmailed": "Poslano emailom",
    "statusSubmitted": "Poslano",
    "statusFailed": "Neuspješno"
  },
  "extracting": "Čitam brojilo...",
  "processing": "Obrada...",
  "photoAlt": "Fotografija brojila",
  "photoLibraryPermissionDenied": "Potrebna je dozvola galerije fotografija za odabir postojeće fotografije.",
  "successEmail": "Email uspješno poslan.",
  "successForm": "Očitanje uspješno poslano.",
  "extractError": "Neuspješno čitanje brojila. Pokušajte s jasnijom fotografijom.",
  "confirmError": "Neuspješno slanje očitanja.",
  "photoTooLarge": "Fotografija je prevelika. Maksimalna veličina je 5MB.",
  "invalidPhoto": "Neispravan format fotografije.",
  "uploadHint": "JPEG, PNG, WebP ili HEIC, do 5MB"
}
